import { render, staticRenderFns } from "./MyDocumentDetails.vue?vue&type=template&id=4d6cfb7a&scoped=true&"
import script from "./MyDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./MyDocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentDetails.vue?vue&type=style&index=0&id=4d6cfb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6cfb7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6cfb7a')) {
      api.createRecord('4d6cfb7a', component.options)
    } else {
      api.reload('4d6cfb7a', component.options)
    }
    module.hot.accept("./MyDocumentDetails.vue?vue&type=template&id=4d6cfb7a&scoped=true&", function () {
      api.rerender('4d6cfb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/MyDocumentDetails.vue"
export default component.exports